const magicRegEx = /(\/magic\/[a-zA-Z0-9]+)/;

export function getStartUrl(pathname: string) {
  let startUrl = window.location.origin;
  if (magicRegEx.test(pathname)) {
    startUrl = window.location.origin + pathname.match(magicRegEx)?.[0];
  }
  return startUrl;
}
